import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=eb6910f4&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb6910f4')) {
      api.createRecord('eb6910f4', component.options)
    } else {
      api.reload('eb6910f4', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=eb6910f4&", function () {
      api.rerender('eb6910f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KL4bT1PVKB6D/JS/pricehelp.vue"
export default component.exports